import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import moment from 'moment';
import { CustomerService } from 'src/app/shareModule/services/customer.service';

@Component({
  selector: 'online-toggle-button',
  templateUrl: './online-toggle-button.component.html',
  styleUrls: ['./online-toggle-button.component.scss']
})
export class OnlineToggleButtonComponent implements OnInit {

  public status: boolean = false;
  public modalRef: any = null;
  public selectedTimer = 0;

  constructor(public auth: AuthServiceService, private toastr: ToastrService, private modalService: NgbModal, private customerService: CustomerService) {

  }

  ngOnInit(): void {
    this._getShopStatus();
  }

  public toggleStatus(value, modal) {
    this.auth.memberShopOnline({ status: value ? 1 : 0 }).subscribe((resp: ApiResponse) => {
      if (value) {
        this.modalRef = this.modalService.open(modal, {
          size: 'sm',
          ariaLabelledBy: 'modal-basic-title',
          windowClass: 'suggestion',
        });
      }
    }, ({ error }: any) => {
      this.toastr.error(error.message);
    });
  }

  public _getShopStatus() {
    this.customerService.getShopStatus().subscribe((resp: ApiResponse) => {
      this.status = resp.body.isOnline
    });
  }

  public selectedTime(time) {
    this.selectedTimer = time;
  }

  public saveTimer() {
    if (this.selectedTimer) {
      let saveDate = moment(new Date()).add(this.selectedTimer, 'hours').toDate().getTime();
      this.auth.addShopTimer({ time: saveDate }).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.modalRef.close();
      });
    }
  }

}
